module.exports = __webpack_public_path__ + "img/xls_icon.2b5481eb.svg";